<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  @if (rows.length === 0) {
    <p class="no-actions-text">No actions were suggested for the analysed non-conformities.</p>
  } @else {
    <table class="actions-table">
      <thead>
        <tr>
          <th>
            <mat-checkbox color="primary"
              [checked]="allSelected"
              [indeterminate]="hasSelectedRows && !allSelected"
              (change)="toggleSelectAll($event.checked)"></mat-checkbox>
          </th>
          <th>Priority</th>
          <th>Outlet</th>
          <th>Location</th>
          <th>Suggested Action</th>
          <th>Reason</th>
          <th>NC References</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track $index) {
          <tr>
            <td>
              <mat-checkbox color="primary" [checked]="row.selected" (change)="row.selected = $event.checked"></mat-checkbox>
            </td>
            <td>
              <span class="priority-badge"
                [class.priority-high]="row.priority === 'High'"
                [class.priority-medium]="row.priority === 'Medium'"
                [class.priority-low]="row.priority === 'Low'">
                {{ row.priority }}
              </span>
            </td>
            <td>{{ row.outletNumber }}</td>
            <td>{{ row.location }}</td>
            <td>{{ actionTypeLabel(row.actionType) }}</td>
            <td class="reason-cell">{{ row.reason }}</td>
            <td>{{ row.ncReferences.join(', ') }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>

<div mat-dialog-actions class="ai-dialog-actions">
  <span class="ai-disclaimer">
    <mat-icon class="ai-disclaimer-icon">auto_awesome</mat-icon>
    AI-generated &ndash; verify before acting
  </span>
  <span class="ai-dialog-actions-spacer"></span>
  @if (onGenerateJobs) {
    <button type="button" mat-stroked-button (click)="generateJobs()" [disabled]="generating || !hasSelectedRows">
      <mat-icon>build</mat-icon>
      {{ generating ? 'Generating...' : 'Generate Jobs' }}
    </button>
  }
  <button type="button" mat-stroked-button (click)="downloadAsPDF()" [disabled]="downloading">
    <mat-icon>picture_as_pdf</mat-icon>
    {{ downloading ? 'Downloading...' : 'Download PDF' }}
  </button>
  <button type="button" mat-raised-button color="primary" class="ai-close-button" (click)="onClose()">Close</button>
</div>
